/**
 * @generated SignedSource<<fb2952ee0bdf4e10646f0810f4d85608>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type useEditorJsField_text$data = {
  readonly blocks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly data: string | null;
        readonly locale: Locale;
      };
    }>;
  };
  readonly " $fragmentType": "useEditorJsField_text";
};
export type useEditorJsField_text$key = {
  readonly " $data"?: useEditorJsField_text$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorJsField_text">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useEditorJsField_text",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TextBlockConnection",
      "kind": "LinkedField",
      "name": "blocks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TextBlockEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TextBlock",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "locale",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "data",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Text",
  "abstractKey": null
};

(node as any).hash = "cc5b5cf28de5aec3835916e2371aa97f";

export default node;
